<header class="header">
  <div class="container" style="padding: 0; position: relative;">
    <p-menubar [model]="items">
      <ng-template pTemplate="item" let-item let-root="root">
        <div
          pRipple
          class="flex align-items-center p-menuitem-link"
          (click)="item.command ? item.command() : null"
        >
          <img *ngIf="item.svg" [src]="item.svg" width="20" height="20" class="menu-icon"/>
          <span class="ml-2">{{ item.label }}</span>
        </div>
      </ng-template>
      
      <ng-template pTemplate="end">
        <!-- 返回上一頁 -->
        <button
          *ngIf="showBackButton"
          pButton
          icon="pi pi-arrow-left"
          class="p-button-text p-button-rounded mr-2"
          (click)="goBack()"
        ></button>
      </ng-template>
    </p-menubar>
      <!-- 置中title -->
      <div class="menubar-title">{{ title }}</div>
  </div>
</header>